import * as React from 'react';
import RecieverList from './CommunicationRecieverList';
import { IAttachments } from '../Types';
import { Translate } from '../../../../../shared/LanguageService';
import { Panel, Button, Row, Col } from 'react-bootstrap';
import Modal from '../BasicOrderInfoModal';
import AttachmentList from './CommunicationAttachmentList';

interface IProps {
    recipients: string[];
    body: string;
    isHtml: boolean;
    attachments: IAttachments[];
    download: (warmStorageReference: string) => void;
    hasFile: boolean;
}

const CommunicationDetailsForm = (props: IProps) => {
    return (
        <div>
            <Panel>
                <Panel.Heading>
                    <Panel.Title>
                        <h3 className="panel-title">
                            {Translate(
                                'view-order/basic-order-info/modal/view-communication-details/panel-headers/recipients'
                            )}
                        </h3>
                    </Panel.Title>
                </Panel.Heading>
                <Panel.Body>
                    <RecieverList items={props.recipients} />
                </Panel.Body>
            </Panel>

            <Panel>
                <Panel.Heading>
                    <Panel.Title>
                        <h3 className="panel-title">
                            {Translate(
                                'view-order/basic-order-info/modal/view-communication-details/panel-headers/body'
                            )}
                        </h3>
                    </Panel.Title>
                </Panel.Heading>
                <Panel.Body>
                    {props.isHtml && <div dangerouslySetInnerHTML={{ __html: props.body }}></div>}
                    {!props.isHtml && <div>{props.body}</div>}
                </Panel.Body>
            </Panel>
            <Panel>
                <Panel.Heading>
                    <Panel.Title>
                        <h3 className="panel-title">
                            {Translate(
                                'view-order/basic-order-info/modal/view-communication-details/panel-headers/attachment'
                            )}
                        </h3>
                    </Panel.Title>
                </Panel.Heading>
                <Panel.Body>
                    {props.hasFile && (
                        <AttachmentList items={props.attachments} download={props.download} />
                    )}
                </Panel.Body>
            </Panel>
        </div>
    );
};

export default CommunicationDetailsForm;
